var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"border header-text",style:({
      backgroundColor: _vm.PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE
    }),attrs:{"cols":"12"}},[_c('h3',{staticClass:"pa-2"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }